import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ModalGroup from "site-apps/assets/ModalGroup";
import ModalIslandSelect from "site-apps/distribution/island/ModalIslandSelect";
import { subscribeEvent, unsubscribeEvent } from "core/eventsConnector";
import WasteTypesSelect from "site-apps/assets/components/WasteTypesSelect";
import DownloadTypesSelect from "site-apps/assets/components/DownloadTypesSelect";
import ContainerTypesSelect from "site-apps/assets/components/ContainerTypesSelect";
import Form from "react-bootstrap/Form";

const TabGeneral = ({ item, add, btnDelete, paramsTypes, formData, setFormData }) => {
    const { t: _tF } = useTranslation("forms");
    const { t: _Tt } = useTranslation("tags");
    const { t: _Tc } = useTranslation("choices");
    const [showModalGroup, setShowModalGroup] = useState(false);
    const [showModalIsland, setShowModalIsland] = useState(false);
    const [group, setGroup] = useState({ id: item.group, name: item.group_name });
    const [island, setIsland] = useState({
        id: item.island,
        name: item.island_name,
    });
    const onSelectGroup = (e) => {
        setShowModalGroup(true);
        subscribeEvent("groupasset:modalselect:change", changeGroup);
    };
    const changeGroup = (e) => {
        setGroup({ id: e.detail.id, name: e.detail.name });
        let data = { ...formData };
        data.group = e.detail.id;
        data.group_name = e.detail.name;
        setFormData(data);
        unsubscribeEvent("groupasset:modalselect:change", changeGroup);
    };
    const onSelectIsland = (e) => {
        setShowModalIsland(true);
        subscribeEvent("island:modalselect:change", changeIsland);
    };
    const changeIsland = (e) => {
        setIsland({ id: e.detail.id, name: e.detail.name });
        let data = { ...formData };
        data.island = e.detail.id;
        data.island_name = e.detail.name;
        setFormData(data);
        unsubscribeEvent("island:modalselect:change", changeIsland);
    };
    useEffect(() => {
        return () => {
            unsubscribeEvent("groupasset:modalselect:change", changeGroup);
            unsubscribeEvent("island:modalselect:change", changeIsland);
        };
    }, []);

    return (
        <>
            <div className="container">
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="uuid" className="col-form-label">
                            UID
                        </label>
                    </div>
                    <div className="col-7">
                        <input type="text" className="form-control" id="uid" name="uid" defaultValue={item.uid} disabled={true} />
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="group_name" className="col-form-label">
                            Grupo
                        </label>
                    </div>
                    <div className="col-7 d-flex">
                        <input type="hidden" id="group" name="group" value={group.id || ""} readOnly={true} />
                        <input
                            type="text"
                            className="form-control"
                            id="group_name"
                            value={group.name || ""}
                            readOnly={true}
                            disabled={true}
                        />
                        {btnDelete ? (
                            <></>
                        ) : (
                            <Button className="" variant="link" type="button" onClick={onSelectGroup}>
                                <FontAwesomeIcon icon="magnifying-glass" />
                            </Button>
                        )}
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="group_name" className="col-form-label">
                            Isla
                        </label>
                    </div>
                    <div className="col-7 d-flex">
                        <input type="hidden" id="island" name="island" value={island.id || ""} readOnly={true} />
                        <input
                            type="text"
                            className="form-control"
                            id="island_name"
                            value={island.name || ""}
                            readOnly={true}
                            disabled={true}
                        />
                        {btnDelete ? (
                            <></>
                        ) : (
                            <Button className="" variant="link" type="button" onClick={onSelectIsland}>
                                <FontAwesomeIcon icon="magnifying-glass" />
                            </Button>
                        )}
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="waste_type" className="col-form-label">
                            Tipo de residuo
                        </label>
                    </div>
                    <div className="col-7">
                        <WasteTypesSelect multiple={false} defaultValue={item.waste_type} />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="download_type" className="col-form-label">
                            {_tF("routes.type-download")}
                        </label>
                    </div>
                    <div className="col-7">
                        <DownloadTypesSelect multiple={false} defaultValue={item.download_type} />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="container_type" className="col-form-label">
                            Tipo de contenedor
                        </label>
                    </div>
                    <div className="col-7">
                        <ContainerTypesSelect multiple={false} defaultValue={item.container_type} />
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="tag" className="col-form-label">
                            TAG
                        </label>
                    </div>
                    <div className="col-7">
                        <input type="text" className="form-control" id="tag" name="tag" defaultValue={item.tag} />
                    </div>
                </div>

                <div className="row g-3 align-items-center mt-3">

                    <div className="col-3 text-end">
                        <label htmlFor="modMass-status" className="col-form-label">
                            {_Tt("common.status")}
                        </label>
                    </div>
                    <div className="col-3">
                        <Form.Select className="mb-2" id="modMass-status" name="status" defaultValue={item.waste_status} >
                            <option value="ac">{_Tc("containerStatus.ac")}</option>
                            <option value="rp">{_Tc("containerStatus.rp")}</option>
                            <option value="rs">{_Tc("containerStatus.rs")}</option>
                            <option value="ds">{_Tc("containerStatus.ds")}</option>
                            <option value="cb">{_Tc("containerStatus.cb")}</option>
                            <option value="ns">{_Tc("containerStatus.ns")}</option>
                        </Form.Select>
                    </div>

                    <div className="col-3 text-end">
                        <label htmlFor="active" className="col-form-label">
                            Activo
                        </label>
                    </div>
                    <div className="col-2">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id="active"
                            name="active"
                            defaultChecked={item.active}
                        />
                    </div>
                </div>
                <div className="row g-3 align-items-center mt-3">
                    <div className="col-3 text-end">
                        <label htmlFor="description" className="col-form-label">
                            Descripción
                        </label>
                    </div>
                    <div className="col-9">
                        <textarea
                            className="form-control"
                            id="description"
                            name="description"
                            defaultValue={item.description}
                            rows="4"
                        />
                    </div>
                </div>
            </div>
            <ModalGroup showModalGroup={showModalGroup} setShowModalGroup={setShowModalGroup} />
            <ModalIslandSelect showModalIsland={showModalIsland} setShowModalIsland={setShowModalIsland} />
        </>
    );
};
export default TabGeneral;
